
import AppFolderList from "@/components/tasks/FolderList.vue";
import AppTaskInfo from "@/components/tasks/TaskInfo.vue";
import AppTaskList from "@/components/tasks/TaskList.vue";
import { MainSocketService } from "@/services";
import { DossierService } from "@/services/dossier-service";
import { ToolbarService } from "@/services/toolbar-service";
import { TasksState } from "@/utils/tasks-state";
import Vue from "vue";
import { MODULE } from "../../config/modules";
import { checkHasModule } from "../../router";

export default Vue.extend({
	data() {
		return {
			ready: false,
			state: new TasksState()
		};
	},
	watch: {
		$route: {
			immediate: true,
			handler() {
				ToolbarService.title = this.$ct("tasks");
				let params = this.$route.params;
				let folderId = parseInt(params.folderId || "0");
				this.state.fetchFolder(folderId);
				let taskId = parseInt(params.taskId || "0");
				this.state.fetchTask(taskId);
			}
		},
		"state.openedTask"(currentValue, prevValue){
			if (!prevValue) return;
			if (currentValue && prevValue.ID == currentValue.ID) return;
			MainSocketService.emit("/task/close", prevValue.ID);
		}
	},
	async created() {
		if (!checkHasModule(MODULE.TAKEN, this.$router)){
			throw new Error("MISSING MODULE");
		};
		await DossierService.getUsers();
		await this.state.fetchFolders();
		this.ready = true;
	},
	destroyed() {
		this.state.unsubscribeFromEvents();
	},
	components: {
		AppFolderList,
		AppTaskList,
		AppTaskInfo
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
